export default __webpack_public_path__ + "static/media/Clarified Soursap.1fd0e8b8.jpg";